import React, { Fragment } from "react";
import GridList, { GridListItem } from "../Lists/GridList";
import Pill from "components/Text/Pill";
import flatCube from "assets/flat-cube.svg";

export default function ContentGridList(props) {
    const bubbleClickAction = (item) => {
        if (props.onSelect) {
            return props.onSelect(item);
        }
    };

    return (
        <GridList>
            {props.items.map((item, index) => (
                <GridListItem key={index}>
                    <ContentGridListItem
                        item={item}
                        onSelect={bubbleClickAction}
                        enableGroupSelect={
                            props.enableGroupSelect ? true : false
                        }
                    />
                </GridListItem>
            ))}
        </GridList>
    );
}

export function ContentGridListItem(props) {
    const handleClick = (e) => {
        if (props.onSelect) {
            props.onSelect(props.item);
        }
    };

    return (
        <Fragment>
            {props.item.attachment ? (
                <div
                    onClick={handleClick}
                    className="group aspect-w-10 aspect-h-7 block w-full cursor-pointer overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-green-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100"
                >
                    <img
                        src={props.item.attachment.imgix_url}
                        alt={props.item.attachment.uuid}
                        className="pointer-events-none object-cover group-hover:opacity-75"
                    />
                    <button
                        type="button"
                        className="focus:outline-none absolute inset-0"
                    >
                        <span className="sr-only">
                            {props.item.title
                                ? props.item.title
                                : props.item.attachment.base_name}
                        </span>
                    </button>
                </div>
            ) : (
                <div
                    onClick={handleClick}
                    className="group aspect-w-10 aspect-h-7 block w-full cursor-pointer overflow-hidden rounded-lg bg-gray-100 focus-within:ring-2 focus-within:ring-green-500 focus-within:ring-offset-2 focus-within:ring-offset-gray-100"
                >
                    <img
                        src={flatCube}
                        alt={props.item.slug}
                        className="pointer-events-none object-cover group-hover:opacity-75"
                    />
                    <button
                        type="button"
                        className="focus:outline-none absolute inset-0"
                    >
                        <span className="sr-only">{props.item.title}</span>
                    </button>
                </div>
            )}
            <p className="pointer-events-none mt-2 block truncate text-sm font-medium text-gray-900">
                {props.item.title
                    ? props.item.title
                    : props.item.attachment.base_name}
            </p>
            <p className="pointer-events-none block text-sm font-medium capitalize text-gray-500">
                <Pill>
                    {props.item.attachment
                        ? props.item.attachment.type
                        : props.item.type}
                </Pill>
            </p>
        </Fragment>
    );
}
